import { render, staticRenderFns } from "./Recos.vue?vue&type=template&id=2e333b60&scoped=true&"
import script from "./Recos.vue?vue&type=script&lang=js&"
export * from "./Recos.vue?vue&type=script&lang=js&"
import style0 from "./Recos.vue?vue&type=style&index=0&id=2e333b60&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e333b60",
  null
  
)

export default component.exports